import http from 'plugins/axios';

export default {
  getUserBillList(data) {
    return http.get({
      url: '/la/admin/workorder/deposite_abnormal_list',
      data
    });
  },
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  },
  reRecharge(data) {
    return http.post({
      url: '/la/admin/workorder/deposit_ensure',
      data,
      dataType: 'form'
    });
  },
  reReset(data) {
    return http.post({
      url: '/la/admin/workorder/deposit_ensure',
      data,
      dataType: 'form'
    });
  }
  // getUserinfo() {
  //   return http.get({
  //     url: '/la/admin/u/infos'
  //   });
  // }
};
